module.exports = __webpack_public_path__ + "static/media/key-isolated-noglow.c622f02f.png";